
import { SMApp, SMUser } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import NoteImageIcon from "@/components/AppMain/assets/note.svg";
import AppProfile from "@/components/V2/AppProfile/AppProfile.vue";
import IconCircleButton from "@/components/V2/IconCircleButton/iconCircleButton.vue";
import Alert from "./AppAlert.vue";

const PAGE_TITLE_CASES = "Cases";

const TOOLBAR_CLASS = "main-toolbar";

const ICONS = {
  arrowBack: "arrow-back",
  chevronForward: "chevron-forward-outline",
};

const NEW_ICONS = {
  arrowBack: "chevron-left",
};

const CASES = "cases";

@Component({
  components: {
    IconCircleButton,
    Alert,
    AppProfile,
  },
})
export default class AppMainToolbar extends Vue {
  @Prop({ type: Boolean, default: false }) readonly sticky?: boolean;

  icons = ICONS;

  NEW_ICONS = NEW_ICONS;

  noteImageIcon = NoteImageIcon;

  get title() {
    return SMApp.currentPageTitle;
  }

  get sectionTitle() {
    return SMApp.currentPageSection;
  }

  get pageTitleLink() {
    return SMApp.pageTitleLink;
  }

  get subTitle() {
    return SMApp.currentPageSubTitle;
  }

  get description() {
    return SMApp.currentPageDescription;
  }

  get legend(): string | undefined {
    return this.$route.meta.legend;
  }

  get mainToolbarTitleClasses() {
    return {
      [`home-title`]: this.$route.fullPath.includes("home"),
    };
  }

  @Watch("$route.fullPath", { immediate: true, deep: true })
  routePathChanged() {
    const pageTitile: string | undefined = this.$route.meta.pageTitile;

    const title: string | undefined = this.$route.meta.title;

    SMApp.setPageTitle(pageTitile || title || "");

    const subTitle: string | undefined = this.$route.meta.subTitle;

    SMApp.setPageSubTitle(subTitle || "");

    const description: string | undefined = this.$route.meta.description;

    SMApp.setPageDescription(description || "");
  }

  get backLink(): string | undefined {
    return this.$route.meta.backLink || SMApp.backLink;
  }

  goBack() {
    if (!this.backLink) return;

    if (SMApp.routerHistory.length === 1 && SMApp.routerHistory[0].includes(CASES)) {
      const id = Number(localStorage.getItem("case_id"));

      const path = `/${CASES}/${id}`;

      this.$router.push(path);

      return;
    }

    let previousPath = SMApp.previousRouterHistoryPath;

    if (!previousPath) previousPath = `${SMUser.basePath}${this.backLink}`;

    if (previousPath.includes("//")) previousPath = previousPath.replace("//", "/");

    this.$router.push(previousPath);
  }

  get isNotesShown() {
    return SMUser.isExpert && SMApp.pageTitle !== PAGE_TITLE_CASES;
  }

  toggleNoteActive() {
    SMApp.toggleNoteActive();
  }

  get hasControls() {
    return !!this.$slots.default;
  }

  get classes() {
    const { sticky } = this;

    return {
      [`${TOOLBAR_CLASS}_sticky`]: !!sticky,
      [`${TOOLBAR_CLASS}_new-version`]: true,
    };
  }

  async openLink(path: string) {
    if (!path) return;

    await this.$router.push(path);
  }
}
